import { render, staticRenderFns } from "./SelectColumns.vue?vue&type=template&id=4fab1e0a"
import script from "./SelectColumns.vue?vue&type=script&lang=ts"
export * from "./SelectColumns.vue?vue&type=script&lang=ts"
import style0 from "./SelectColumns.vue?vue&type=style&index=0&id=4fab1e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports